"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.surface = exports.floating = exports.shadow = exports.selected = exports.pressed = exports.hover = exports.focus = exports.disabled = exports.rested = void 0;

var _core = require("@emotion/core");

var _palette = require("../palette");

const surfaceRested = ({
  theme
}) => (0, _core.css)`
  background-color: ${theme.uSurfaceRested};
  border: 1px solid ${(0, _palette.color)(theme, 'neutral03')};
`;

exports.rested = surfaceRested;

const surfaceDisabled = ({
  theme
}) => (0, _core.css)`
  background-color: ${theme.uSurfaceDisabled};
  border: 1px solid ${(0, _palette.color)(theme, 'neutral04')};
  box-shadow: none;
`;

exports.disabled = surfaceDisabled;

const surfaceFocus = ({
  theme
}) => (0, _core.css)`
  background-color: ${theme.uSurfaceRested};
  border: 2px dashed ${(0, _palette.color)(theme, 'secondary03')};
`;

exports.focus = surfaceFocus;

const surfaceHover = ({
  theme
}) => (0, _core.css)`
  background-color: ${theme.uSurfaceHover};
  border: 1px solid ${(0, _palette.color)(theme, 'secondary05')};
  box-shadow: 0 8px 16px 0 rgba(170, 187, 187, 0.5);
  position: relative;
`;

exports.hover = surfaceHover;

const surfacePressed = ({
  theme
}) => (0, _core.css)`
  background-color: ${theme.uSurfacePressed};
  border: 1px solid ${(0, _palette.color)(theme, 'secondary05')};
`;

exports.pressed = surfacePressed;

const surfaceSelected = ({
  theme
}) => (0, _core.css)`
  background-color: ${theme.uSurfaceSelected};
  border: 1px solid ${(0, _palette.color)(theme, 'secondary05')};
`;

exports.selected = surfaceSelected;

const surfaceShadow = ({
  theme
}) => (0, _core.css)`
  background-color: ${theme.uSurfaceShadow};
  border: 1px solid ${(0, _palette.color)(theme, 'neutral03')};
  box-shadow: 0 8px 16px 0 rgba(170, 187, 187, 0.5);
  position: relative;
`;

exports.shadow = surfaceShadow;

const surfaceFloating = ({
  theme
}) => (0, _core.css)`
  background-color: ${theme.uSurfaceFloating};
  border: 1px solid ${(0, _palette.color)(theme, 'neutral03')};
  box-shadow: 0 8px 40px 0 rgba(170, 187, 187, 0.25);
  position: relative;
`;

exports.floating = surfaceFloating;

const surface = ({
  disabled,
  focus,
  hover,
  pressed,
  selected,
  shadow,
  floating,
  ...props
}) => (0, _core.css)`
  ${surfaceRested(props)};
  ${disabled && surfaceDisabled(props)};
  &:disabled {
    ${surfaceDisabled(props)};
  }
  ${focus && surfaceFocus(props)};
  &:focus {
    ${surfaceFocus(props)};
  }
  ${hover && surfaceHover(props)};
  &:hover {
    ${surfaceHover(props)};
  }
  ${pressed && surfacePressed(props)};
  ${selected && surfaceSelected(props)};
  ${shadow && surfaceShadow(props)};
  ${floating && surfaceFloating(props)};
`;

exports.surface = surface;